const common = {
  site_name: '片多多影视',
  site_description: '海量高清免费影视资源，不卡顿在线观看',
  nav_home: '首页',
  nav_category: '分类',
  nav_about: '关于我们',
  hero_cta: '立即观看',
  hero_learn_more: '了解更多',
  featured_title: '热门推荐',
  featured_view_all: '查看全部',
  category_title: '影视分类',
  article_title: '影视资讯',
  faq_title: '常见问题',
  footer_copyright: '版权所有',
  contact_us: '联系我们',
  newsletter_title: '订阅片多多影视资讯',
  newsletter_btn: '立即订阅',
};

export default common;